import { render, staticRenderFns } from "./CreatorsListTabs.vue?vue&type=template&id=06e4b1a4&scoped=true&"
import script from "./CreatorsListTabs.vue?vue&type=script&lang=ts&"
export * from "./CreatorsListTabs.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorsListTabs.vue?vue&type=style&index=0&id=06e4b1a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e4b1a4",
  null
  
)

export default component.exports